





























import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import ProbabilisticInputs from '@/modules/lcca/views/components/ProbablisticInputs.vue';
import { BaseProbVariables } from '@/modules/lcca/interfaces/probabilistic';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';
import { createLccaValidations } from '@/modules/lcca/lib/validations';


@Component({
  components: {
    PxNumberInput,
    // InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
    ProbabilisticInputs,
  },
})
export default class LccaUserTime extends Vue {
  @Prop() readonly pxLccaId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    return lccaStore.currentImperial;
  }

  validations() {
    return createLccaValidations(this.scenarioImperial);
  }

  sync() {
    lccaStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    lccaStore.saveCurrentScenario();
  }

  get probInputsList() {
    return [
      {
        value: this.passengerProbabilisticInputs,
        title: 'Value of time for passenger cars',
        unit: '$/hour',
      },
      {
        value: this.singleTruckProbabilisticInputs,
        title: 'Value of time for single trucks',
        unit: '$/hour',
      },
      {
        value: this.comboTruckProbabilisticInputs,
        title: 'Value of time for combination trucks',
        unit: '$/hour',
      },

    ];
  }

  get userProbInputs() {
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }

  get passengerProbabilisticInputs() {
    return this.scenario.probabilistic.filter((P) => P.name === BaseProbVariables.passengerCarsTime)[0];
  }

  get singleTruckProbabilisticInputs() {
    return this.scenario.probabilistic.filter((P) => P.name === BaseProbVariables.singleUnitTrucksTime)[0];
  }

  get comboTruckProbabilisticInputs() {
    return this.scenario.probabilistic.filter((P) => P.name === BaseProbVariables.combinationTrucksTime)[0];
  }
}

